import { getLocalizedMeta } from '@/utils/common'

const Layout = () => import('@/layout/index.vue')

export default {
  name: 'About',
  path: '/:language?/about',
  component: Layout,
  redirect: '/about/index',
  children: [
    {
      name: 'AboutIndex',
      path: 'index',
      component: () => import('@/views/about/index.vue'),
      meta: {
        hideTab: false,
        menu: 'About',
        ...getLocalizedMeta('about')
      }
    }
  ]
}
